"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    "horizontal-bar": require("./elements/HorizontalBar.vue").default
  },

  props: ["item"]
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/charts/IntervalBarChart.vue
// module id = GW+n
// module chunks = 0 1